import { format, isAfter, subHours } from "date-fns";
import { sv } from "date-fns/locale";
import DOMPurify from "dompurify";
import { useRootStore } from "store";

import { useGlobalContext } from "app/store/GlobalContext";
import { MessageItem } from "models/inbox/inbox";

import { Attach16Regular } from "@fluentui/react-icons";
import "../index.scss";

type Props = {
  message: MessageItem;
  threadId: string;
  threadLink: string;
};

export default function ThreadSidebarMessageItem({
  message,
  threadId,
  threadLink
}: Props) {
  const { handleNavigation } = useGlobalContext();

  const { selectedMessageId, setSelectedMessageId, currentThread } =
    useRootStore((state) => state.inbox);

  const { createdAt, messageId, formatedFrom, body, attachments } = message;
  const yesterday = subHours(new Date(), 24);
  const messageDate = new Date(createdAt);
  const isRecent = isAfter(messageDate, yesterday);

  const isActive =
    selectedMessageId === messageId && currentThread?.threadId === threadId;

  const displayDate = isRecent
    ? format(messageDate, "HH:mm")
    : format(messageDate, "yyyy/MM/dd", { locale: sv });

  const createMarkup = () => {
    return { __html: DOMPurify.sanitize(body) };
  };

  const handleSelectMessage = (e: React.MouseEvent) => {
    e.stopPropagation();
    setSelectedMessageId(messageId);
    handleNavigation({
      url: threadLink,
      eventTitle: "Thread",
      e: e
    });
  };

  return (
    <div
      className={`thread-sidebar-message-wrapper w-100 ${isActive ? "active-message" : ""}`}
      onClick={handleSelectMessage}
    >
      <div className="d-flex justify-content-between my-1">
        <div className="message-subject">{formatedFrom}</div>
        <div className="d-flex align-items-center gap-2">
                {attachments && attachments.length > 0 && 
                <Attach16Regular />
                }
                <div className="message-time fw-normal">{displayDate}</div>
              </div>
      </div>

      <div
        className="html-editor thread-message fw-normal mb-1 message-content html-editor-truncate-text"
        dangerouslySetInnerHTML={createMarkup()}
      />
    </div>
  );
}
